/* eslint-disable spire/export-styles */
import { getPageByUrl, PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {}

interface OwnProps extends WidgetProps {
    fields: {};
}

export interface NavigationListStyles {
    linkStyles: InjectableCss;
}

const navigationListStyles: NavigationListStyles = {
    linkStyles: {
        css: css``,
    },
};

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    website: state.context.website,
});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

// eslint-disable-next-line react/prefer-stateless-function
class ConfiguratorWidget extends React.Component<Props> {
    render() {
        const siteUri = new URL(this.props.website.uri);
        const baseUrl = `https://${siteUri.hostname}/ProcessConfiguratorSelections`;
        return (
            <div style={{ width: 1000, height: 1000 }}>
                <iframe
                    width="100%"
                    height="100%"
                    src={`https://configurator.rockwellautomation.com/#/browse?redirect_uri=${baseUrl}`}
                    title="Rockwell Configurator"
                ></iframe>
            </div>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ConfiguratorWidget),
    definition: {
        group: "Basic",
        icon: "ConfiguratorWidget",
        fieldDefinitions: [],
    },
};

export default widgetModule;
